import script from "./shopGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./shopGroup.vue?vue&type=script&setup=true&lang=js"

import "./shopGroup.vue?vue&type=style&index=0&id=01c9c6b9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c9c6b9"]])

export default __exports__